import script from "./KpiRow.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiRow.vue?vue&type=script&setup=true&lang=js"

import "./KpiRow.vue?vue&type=style&index=0&id=571c7adf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-571c7adf"]])

export default __exports__